<template>
  <v-app id="app">
    <div>
      <v-app-bar app style="background-color: #000000;">
        <Header
          :title="headerTitle"
          :home-button="showHomeButton"
          @back-to-all="backToHome"
        />
      </v-app-bar>
      <v-main>
        <template v-if="selectedApiIndex === null || selectedApiIndex < 0">
          <div>
            <br />
            <document-list
              :documents="apiDocs"
              @select-document="selectApi"
            ></document-list>
          </div>
        </template>
        <template v-else>
          <api-doc
            :goto-path="goToHash"
            :doc-url="selectedApi ? selectedApi.spec_url : ''"
          ></api-doc>
        </template>
      </v-main>
    </div>
  </v-app>
</template>

<script>
import documents from "@/documents";
import Header from "@/components/Header";
import ApiDoc from "./components/ApiDoc.vue";
import DocumentList from "./components/DocumentList.vue";

export default {
  name: "App",
  components: {
    Header,
    ApiDoc,
    DocumentList
  },
  data() {
    return {
      apiDocs: documents,
      selectedApiIndex: null,
      goToHash: undefined
    };
  },
  watch: {
    $route: {
      handler: function(newRoute) {
        if (!newRoute.query.page) this.selectedApiIndex = null;
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    selectedApi() {
      return this.apiDocs[this.selectedApiIndex];
    },
    headerTitle() {
      return this.selectedApi
        ? this.selectedApi.title + " API Documentation"
        : "API Documentation";
    },
    routeApiName() {
      const urlParams = new URLSearchParams(window.location.search);
      const page = urlParams.get("page");
      return page;
    },
    showHomeButton() {
      let show = Boolean(
        this.selectedApiIndex !== null && this.selectedApiIndex > -1
      );
      return show;
    }
  },
  methods: {
    init() {
      if (this.routeApiName) this.selectApi(this.routeApiName);
    },
    selectApi(serviceName) {
      const getPageIndex = this.apiDocs.findIndex(
        p => p.service_name === serviceName
      );

      if (getPageIndex > -1) {
        this.$router.push(
          {
            query: {
              page: this.apiDocs[getPageIndex].service_name
            },
            hash: window.location.hash
          },
          () => {
            this.selectedApiIndex = getPageIndex > -1 ? getPageIndex : null;
          }
        );
      } else {
        this.backToHome();
      }
    },
    backToHome() {
      this.$router.push({
        name: "Home"
      });
      this.selectedApiIndex = null;
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style>
#app {
  font-size: inherit;
  background-color: rgb(51, 51, 51);
}
</style>
